import * as yup from 'yup'

export class ResetPasswordDto {
  email?: string = ''
  password?: string = ''
  confirmPassword?: string = ''
}

export const resetPasswordValidationSchema = yup.object({
  email: yup.string().email('Email').required('Field is required'),
  password: yup
    .string()
    .min(8)
    .max(64)
    .matches(
      /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,64}$/,
      'Password Must Contain at Least One Uppercase Letter, One Lowercase Letter, and One Number.'
    )
    .required('Field is required'),
  confirmPassword: yup
    .string()
    .oneOf([yup.ref('password')], 'Password and Confirm Password Must Match.')
    .required('Field is required')
})
